<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashout"
  header="Nuevo cashout USDT"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '900px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'USDT'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType !== 'csv'">
    <div class="form-heading">
      <div class="form-title">Ingresa los datos del cashout USDT</div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="usdt_transaction_id"
                >ID de la transacción (Opcional)</label
              >
              <input
                id="usdt_transaction_id"
                type="number"
                placeholder="Ingresa el ID de la transacción"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="usdt_amount">Monto</label>
              <input
                id="usdt_amount"
                type="number"
                placeholder="Ingresa el monto del cashout"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="usdt_client_id">Cliente asignado</label>
              <p-dropdown
                inputId="usdt_client_id"
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>
          </div>

          <div class="filter-column">
            <div class="form-item">
              <label for="usdt_firstname">Nombres</label>
              <input
                id="usdt_firstname"
                type="text"
                placeholder="Ingresa los nombres"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="usdt_lastname">Apellidos</label>
              <input
                id="usdt_lastname"
                type="text"
                placeholder="Ingresa los apellidos"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="usdt_description">Descripción (Opcional)</label>
              <input
                id="usdt_description"
                type="text"
                placeholder="Ingresa una descripción"
                formControlName="description"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>

          <div class="filter-column">
            <div class="form-item">
              <label for="usdt_network">Red</label>
              <p-dropdown
                inputId="usdt_network"
                placeholder="Elige la red"
                formControlName="account_type"
                [options]="networkOptions"
                (onChange)="setNetwork($event.value)"
                appendTo="body"
              />
            </div>

            <div class="form-item">
              <label for="usdt_account_number">Dirección destino</label>
              <input
                id="usdt_account_number"
                type="text"
                placeholder="Ingresa la dirección USDT"
                formControlName="account_number"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="ctx.newTransactionForm.invalid || ctx.addingTransaction"
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file_usdt"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
      />
      <label class="csv-upload-box" for="cashout_csv_file_usdt">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />
        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
